<template>
  <div>
    <div class="step">
      <Steps :current="current">
        <Step :title="langMap.step1[lang]" :content="langMap.baseInfoMaintain[lang]"></Step>
        <Step :title="langMap.step2[lang]" :content="langMap.selectTaskJob[lang]"></Step>
      </Steps>
    </div>
    <div>
      <div ref="baseStep" v-if="current===0">
        <Form ref="baseFormValidate" :model="baseForm" :rules="baseFormRuleValidate" :label-width="80">
          <FormItem :label="langMap.name[lang]" prop="name">
            <Input v-model="baseForm.name" style="width: 500px" :placeholder="langMap.inputName[lang]"/>
          </FormItem>
          <FormItem :label="langMap.type[lang]" prop="type">
            <Input v-model="baseForm.type" style="width: 500px" :placeholder="langMap.inputType[lang]"/>
          </FormItem>
          <FormItem :label="langMap.belongStation[lang]" prop="stationId">
            <Select v-model="baseForm.stationId" style="width: 500px">
              <Option v-for="item in stationList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem :label="langMap.description[lang]">
            <Input v-model="baseForm.description" style="width: 500px" type="textarea" :autosize="{minRows: 4,maxRows: 8}" :placeholder="langMap.jobDescInfo[lang]"/>
          </FormItem>
        </Form>
      </div>
      <div ref="pathStep" v-if="current===1">
        <Card :bordered="false">
          <div slot="title">
            <Row>
              <Col :xs=12 :sm=12>
                <Form :label-width="70" inline>                 
                    <FormItem :label="langMap.selectJob[lang]" class="leftFlex">
                      <Select v-model="selectedPath" filterable clearable>
                        <Option v-for="item in taskPathAllList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                      </Select>
                    </FormItem>
                    <FormItem :label="langMap.cycles[lang]" class="leftFlex cycles-form-item" :error="cyclesError">
                      <InputNumber :max="100000" :min="1" :step="1" v-model="cycles" @on-blur="validateCyclesOnBlur" @on-change="clearCyclesError"/>
                    </FormItem>
                    <Button type="primary" style="margin-left:20px;" @click="addTaskPath">{{langMap.add[lang]}}</Button>
                </Form>
              </Col>
            </Row>
          </div>
          <Table :loading="tableLoading" border :columns="taskPathCol" :data="paths"></Table>
        </Card>
      </div>
      <!-- <div ref="commandStep" v-if="current===2">
        <Row>
          <Col :xs=12 :sm=12>
            <Card :bordered="false">
              <div slot="title">
                <Row>
                  <Col :xs=24 :sm=24>
                      <div style="text-align:right;padding-top:10px;">
                        <Button type="primary" style="margin-left:20px;" @click="triggerModelShow(true, null)">{{langMap.addTrigger[lang]}}</Button>
                      </div>
                  </Col>
                </Row>
              </div>
              <Table :loading="tableLoading" highlight-row @on-current-change="selectRow" border :columns="triggerCol" :data="triggers"></Table>
            </Card>
          </Col>
          <Col :xs=12 :sm=12>
            <Card :bordered="false">
              <div slot="title">
                <Row>
                  <Col :xs=24 :sm="24">
                    <div style="text-align:right;padding-top:10px;">
                      <Button type="primary" :disabled="addActionBtn" style="margin-left:20px;" @click="actionModelShow(true, null)">{{langMap.addAction[lang]}}</Button>
                    </div>
                  </Col>
                </Row>
              </div>
              <Table :loading="tableLoading" border :columns="actionCol" :data="actions"></Table>
            </Card>
          </Col>
        </Row>
      </div> -->
    </div>
    <div style="text-align:center;padding-top:10px;">
      <Button type="primary" v-if="current>0" @click="clickBack">{{langMap.prev[lang]}}</Button>
      <Button type="primary" v-if="current<=1" style="margin-left:20px;" @click="clickNext">{{current === 1 ? langMap.finish[lang] : langMap.next[lang]}}</Button>
    </div>

    <!-- 触发器新建、编辑 -->
    <Modal :mask-closable="false" v-model="triggerModal" :title="langMap.trigger[lang]">
      <Form ref="triggerFormValidate" :model="triggerForm" :rules="triggerRuleValidate" :label-width="100">
        <FormItem :label="langMap.triggerName[lang]" prop="name">
          <Select v-model="triggerForm.name" clearable>
            <Option :key="item.id" :value="item.id" v-for="item in triggerNames">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem :label="langMap.triggerType[lang]" prop="type">
          <Select v-model="triggerForm.type" clearable>
            <Option :key="item.id" :value="item.id" v-for="item in triggerTypes" >{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem :label="langMap.pathNode[lang]" v-if="triggerForm.type==='TYPE_FACTOR'" prop="data">
          <Select v-model="triggerForm.routeid" @on-change="updatePathNodes">
            <Option v-for="item in paths" :value="item.pathId" :key="item.pathId">{{item.name}}</Option>
          </Select>
          <Select v-model="triggerForm.nodeid">
            <Option v-for="item in nodes" :value="item.id" :key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem :label="langMap.latLng[lang]"  v-if="triggerForm.type==='TYPE_POSITION'" prop="data">
          <Input v-model="triggerForm.lat" :placeholder="langMap.inputLatitude[lang]" clearable/><br/>
          <Input v-model="triggerForm.lon" :placeholder="langMap.inputLongitude[lang]" clearable/>
        </FormItem>
        <FormItem :label="langMap.guide[lang]"  v-if="triggerForm.type==='TYPE_GUIDE'" prop="data">
          <InputNumber  v-model="triggerForm.top" style="width: 50%" :placeholder="langMap.inputTop[lang]" clearable/><br/>
          <InputNumber  v-model="triggerForm.left" style="width: 50%" :placeholder="langMap.inputLeft[lang]" clearable/><br/>
          <InputNumber  v-model="triggerForm.right" style="width: 50%" :placeholder="langMap.inputRight[lang]" clearable/><br/>
          <InputNumber  v-model="triggerForm.bottom" style="width: 50%" :placeholder="langMap.inputBottom[lang]" clearable/><br/>
          <InputNumber  v-model="triggerForm.timestamp" style="width: 50%" :placeholder="langMap.inputTimestamp[lang]" clearable/>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text"  :loading="btnLoading" @click="cancelTrigger">{{langMap.cancel[lang]}}</Button>
        <Button type="primary" :loading="btnLoading" @click="saveTrigger">{{langMap.save[lang]}}</Button>
      </div>
    </Modal>

    <!-- 动作新建、编辑 -->
    <Modal :mask-closable="false" v-model="actionModal" :title="langMap.action[lang]">
      <Form ref="actionFormValidate" :model="actionForm" :rules="actionRuleValidate" :label-width="100">
        <FormItem :label="langMap.actionName[lang]" prop="name">
          <Select v-model="actionForm.name" clearable @on-change="updateActionType">
            <Option :key="item.id" :value="item.id" v-for="item in actionNames">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem :label="langMap.actionType[lang]" prop="type">
          <Select v-model="actionForm.type" disabled>
            <Option :key="item.id" :value="item.id" v-for="item in actionTypes" >{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem :label="langMap.patrolData[lang]" v-if="actionForm.name==='BO_PATROL'"  prop="data">
          <InputNumber  v-model="actionForm.round" :min="0" style="width: 50%" :placeholder="langMap.inputRounds[lang]" clearable/><br/>
        </FormItem>
        <FormItem :label="langMap.speakerData[lang]"  v-if="actionForm.name==='EQ_SPEAKER'" prop="data">
          <i-switch  v-model="actionForm.switch">
            <span slot="open">{{langMap.on[lang]}}</span>
            <span slot="close">{{langMap.off[lang]}}</span>
          </i-switch ><br/>
          <Select v-model="actionForm.speakerDataType" clearable>
            <Option :key="item.id" :value="item.id" v-for="item in speakerDataTypes">{{item.name}}</Option>
          </Select><br/>
          <Input v-model="actionForm.url" :placeholder="langMap.inputSoundUrl[lang]" clearable/><br/>
          <Input v-model="actionForm.voice" :placeholder="langMap.inputVoiceId[lang]" clearable/><br/>
          <InputNumber  v-model="actionForm.times" style="width: 50%" :placeholder="langMap.inputPlayTimes[lang]" clearable/><br/>
          <InputNumber  v-model="actionForm.interval" style="width: 50%" :placeholder="langMap.inputPlayInterval[lang]" clearable/><br/>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text"  :loading="btnLoading" @click="cancelAction">{{langMap.cancel[lang]}}</Button>
        <Button type="primary" :loading="btnLoading" @click="saveAction">{{langMap.save[lang]}}</Button>
      </div>
    </Modal>

  </div>
</template>
<script>
import api from "../../../api";
import CollapsedMenu from "../../../components/main/components/side-menu/collapsed-menu";
import langMap from '@/utils/language';
import { t } from '@/utils/language';
import { mapState } from 'vuex';

const validStation = (rule, value, callback) => {
  if (!value && value !== 0) {
    callback(new Error(t('stationRequired')));
  } else {
    callback();
  }
};
const validName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(t('nameRequired')));
      }
      callback();
};
const validType = (rule, value, callback) => {
  if (!value) {
    return callback(new Error(t('typeRequired')));
  }
  callback();
};  
const validTriggerName = (rule, value, callback) => {
  if (!value) {
    return callback(new Error(t('triggerNameRequired')));
  }
  callback();
};
const validTriggerType = (rule, value, callback) => {
  if (!value) {
    return callback(new Error(t('triggerTypeRequired')));
  }
  callback();
};
const validActionName = (rule, value, callback) => {
  if (!value) {
    return callback(new Error(t('actionNameRequired')));
  }
  callback();
};
const validActionType = (rule, value, callback) => {
  if (!value) {
    return callback(new Error(t('actionTypeRequired')));
  }
  callback();
};

export default {
  name: "TaskForm",
  components: { CollapsedMenu },
  props: {
    taskData: Object
  },
  data() {
   const validateTriggerData = (rule, value, callback) => {
      if (this.triggerForm.type === "TYPE_FACTOR") {
        if (!this.triggerForm.routeid && !this.triggerForm.nodeid) {
          return callback(new Error(t('pathNodeRequired')));
        } else {
          callback();
        }
      } else if (this.triggerForm.type === "TYPE_POSITION") {
        if (!this.triggerForm.lat || !this.triggerForm.lon) {
          return callback(new Error(t('latLngRequired')));
        } else {
          callback();
        }
      } else if (this.triggerForm.type === "TYPE_GUIDE") {
        if (
          !this.triggerForm.top &&
          !this.triggerForm.left &&
          !this.triggerForm.right &&
          !this.triggerForm.bottom &&
          !this.triggerForm.timestamp
        ) {
          return callback(new Error(t('guideDataRequired')));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };

    const validateActionData = (rule, value, callback) => {
      if (this.actionForm.name === "BO_PATROL") {
        if (!this.actionForm.round) {
          return callback(new Error(t('roundsRequired')));
        } else {
          callback();
        }
      } else if (this.actionForm.name === "EQ_SPEAKER") {
        if (
          !this.actionForm.speakerDataType &&
          !this.actionForm.url &&
          !this.actionForm.voice &&
          !this.actionForm.times &&
          !this.actionForm.interval
        ) {
          return callback(new Error(t('speakerDataRequired')));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };

    return {
      langMap:langMap,
      task: null,
      baseForm: {
        id: "",
        name: "",
        type: "",
        description: "",
        stationId: ""
      },
      current: 0,
      btnLoading: false,
      selectedPath: null,
      paths: [], //已选择作业列表
      cycles: 1, // 任务圈数
      cyclesError: '', // 圈数错误提示
      nodes: [],
      taskPathAllList: [], //带选择作业列表
      tableLoading: false,
      stationList: [], // 归属站点列表
      triggerTypes: [],
      triggerNames: [],
      actionNames: [],
      actionTypes: [],

      triggers: [],
      selectedTrigger: null,
      triggerModal: false,
      triggerForm: {
        id: "",
        taskId: "",
        name: "",
        type: "",
        data: "",
        routeid: "",
        nodeid: "",
        lat: null,
        lon: null,
        top: null,
        left: null,
        right: null,
        bottom: null,
        timestamp: null
      },

      addActionBtn: true,
      actions: [],
      actionModal: false,
      actionForm: {
        id: "",
        taskId: "",
        triggerId: "",
        name: "",
        type: "",
        data: "",
        round: null,
        switch: false,
        speakerDataType: null,
        url: null,
        voice: null,
        times: null,
        interval: null
      },
      baseFormRuleValidate:{
        name: [{ required: true, validator: validName, trigger: "blur" }],
        type: [{ required: true, validator: validType, trigger: "blur" }],
        stationId: [
          { required: true, validator: validStation, trigger: "change" }
        ]
      },
      triggerRuleValidate:{
        name: [
          { required: true, validator: validTriggerName, trigger: "change" }
        ],
        type: [
          { required: true, validator: validTriggerType, trigger: "change" }
        ],
        data: [{ validator: validateTriggerData, trigger: "change" }]
      },
      actionRuleValidate:{
        name: [
          { required: true, validator: validActionName, trigger: "change" }
        ],
        type: [
          { required: true, validator: validActionType, trigger: "change" }
        ],
        data: [{ validator: validateActionData, trigger: "change" }]
      }
    };
  },
  computed: {
    ...mapState({
      lang: state => state.app.language 
    }),
    speakerDataTypes(){
      return [
        {
          id: "STREAMING",
          name: langMap.streaming[this.lang]
        },
        {
          id: "LOCAL",
          name: langMap.local[this.lang]
        }
      ]
    },
    taskPathCol(){
      return [
      {
          title: "#",
          width: 80,
          key: "index",
          render(h, params) {
            return h("span", params.index + 1);
          }
        },
        {
          title: langMap.jobName[this.lang],
          key: "name"
        },
        {
          title: langMap.cycles[this.lang],
          key: "cycles",
          // 处理圈数为空的情况
          render: (h, params) => h('span', params.row.cycles || 1)
        },
        {
          title: langMap.operation[this.lang],
          width: 300,
          align: "center",
          render: (h, params) => {
            //渲染数组
            var renderArray = [];
            renderArray.push(
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small"
                  },
                  style: {
                    padding: "1px",
                    color: "#2d8cf0"
                  },
                  on: {
                    click: () => {
                      // params.row
                      this.$Modal.confirm({
                        title: langMap.systemTip[this.lang],
                        content: langMap.confirmDelete[this.lang],
                        okText: langMap.confirm[this.lang],
                        cancelText: langMap.cancel[this.lang],
                        onOk: () => {
                          this.$Spin.show();
                          api
                            .getData(
                              "task-server/task/path/delete?id=" +
                                params.row.id,
                              this
                            )
                            .then(res => {
                              if (res.state == 0) {
                                this.$Notice.error({
                                  title: langMap.tip[this.lang],
                                  desc: res.msg
                                });
                              } else {
                                this.getTaskPath();
                              }
                              this.$Spin.hide();
                            });
                        }
                      });
                    }
                  }
                },
                langMap.delete[this.lang]
              )
            );
            return h("div", renderArray);
          }
        }
      ]
    },
    triggerCol(){
      return [
      {
          title: "#",
          width: 80,
          key: "index",
          render(h, params) {
            return h("span", params.index + 1);
          }
        },
        {
          title: langMap.triggerName[this.lang],
          key: "nameStr"
        },
        {
          title: langMap.triggerType[this.lang],
          key: "typeStr"
        },
        {
          title: langMap.operation[this.lang],
          width: 200,
          align: "center",
          render: (h, params) => {
            //渲染数组
            var renderArray = [];
            renderArray.push(
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small"
                  },
                  style: {
                    padding: "1px",
                    color: "#2d8cf0"
                  },
                  on: {
                    click: () => {
                      this.triggerModelShow(true, params.row);
                    }
                  }
                },
                langMap.modify[this.lang]
              )
            );
            renderArray.push(
              h("Divider", {
                props: {
                  type: "vertical"
                },
                style: {
                  margin: "0 2px"
                }
              })
            );
            renderArray.push(
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small"
                  },
                  style: {
                    padding: "1px",
                    color: "#2d8cf0"
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: langMap.systemTip[this.lang],
                        content: langMap.confirmDelete[this.lang],
                        okText: langMap.confirm[this.lang],
                        cancelText: langMap.cancel[this.lang],
                        onOk: () => {
                          this.$Spin.show();
                          api
                            .getData(
                              "task-server/task/trigger/delete?id=" +
                                params.row.id,
                              this
                            )
                            .then(res => {
                              if (res.state == 0) {
                                this.$Notice.error({
                                  title: langMap.tip[this.lang],
                                  desc: res.msg
                                });
                              } else {
                                //初始化右侧内容
                                // 删除成功后:
                                // 1. 刷新触发器列表
                                this.getTriggers();
                              }
                              this.$Spin.hide();
                            });
                        }
                      });
                    }
                  }
                },
                langMap.delete[this.lang]
              )
            );
            return h("div", renderArray);
          }
        }
      ]
    },
    actionCol(){
      return [
      {
          title: "#",
          width: 80,
          key: "index",
          render(h, params) {
            return h("span", params.index + 1);
          }
        },
        {
          title: langMap.actionName[this.lang],
          key: "nameStr"
        },
        {
          title: langMap.actionType[this.lang],
          key: "typeStr"
        },
        {
          title: langMap.operation[this.lang],
          width: 200,
          align: "center",
          render: (h, params) => {
            //渲染数组
            var renderArray = [];
            renderArray.push(
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small"
                  },
                  style: {
                    padding: "1px",
                    color: "#2d8cf0"
                  },
                  on: {
                    click: () => {
                      this.actionModelShow(true, params.row);
                    }
                  }
                },
                langMap.modify[this.lang]
              )
            );
            renderArray.push(
              h("Divider", {
                props: {
                  type: "vertical"
                },
                style: {
                  margin: "0 2px"
                }
              })
            );
            renderArray.push(
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small"
                  },
                  style: {
                    padding: "1px",
                    color: "#2d8cf0"
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: langMap.systemTip[this.lang],
                        content: langMap.confirmDelete[this.lang],
                        okText: langMap.confirm[this.lang],
                        cancelText: langMap.cancel[this.lang],
                        onOk: () => {
                          this.$Spin.show();
                          api
                            .getData(
                              "task-server/task/trigger/action/delete?id=" +
                                params.row.id,
                              this
                            )
                            .then(res => {
                              if (res.state == 0) {
                                this.$Notice.error({
                                  title: langMap.tip[this.lang],
                                  desc: res.msg
                                });
                              } else {
                                //刷新右侧列表
                                this.getActions();
                              }
                              this.$Spin.hide();
                            });
                        }
                      });
                    }
                  }
                },
                langMap.delete[this.lang]
              )
            );
            return h("div", renderArray);
          }
        }
      ]
    }
  },
  methods: {
    clickBack() {
      this.current -= 1;
    },
    clickNext() {
      if (this.current === 0) {
        //保存基本信息
        this.saveBase();
      } else if (this.current === 1) {
        //选择作业点击完成，校验作业是否选择
        if (!this.paths || this.paths === null || this.paths.length < 1) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: langMap.noJobsSelected[this.lang],
          });
        } else {
          //直接完成
          this.finish();
        }
      }
    },
    gotoNext(current) {
      this.current = current;
      if (this.current === 1) {
        //第二步骤，初始化数据
        this.getTaskPath();
        this.getTaskPathAll();
      } else if (this.current === 2) {
        //第三步骤，初始化数据
        this.getTriggers();
      }
    },

    getTaskPathAll() {
      this.tableLoading = true;
      const _str = `&stationId=${this.baseForm.stationId}`;
      api.getData("task-server/path/listAll?status=3"+ _str, this).then(res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg
          });
        } else {
          this.taskPathAllList = res.data;
        }
      });
      this.tableLoading = false;
    },

    finish() {
      this.tableLoading = true;
      api
        .getData("task-server/task/enable?id=" + this.task.id, this)
        .then(res => {
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.tip[this.lang],
              desc: res.msg
            });
          } else {
            //关闭窗口，刷新上一页
            this.$emit("changePageShow");
          }
        });
      this.tableLoading = false;
    },

    //获取已经选择作业列表
    getTaskPath() {
      if (this.task && this.task.id) {
        this.tableLoading = true;
        api.getData("task-server/task/path/" + this.task.id, this).then(res => {
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.tip[this.lang],
              desc: res.msg
            });
          } else {
            this.paths = res.data;
          }
        });
        this.tableLoading = false;
      }
    },

    updatePathNodes() {
      if (this.triggerForm.routeid) {
        this.tableLoading = true;
        api
          .getData(
            "task-server/node/get/path/" + this.triggerForm.routeid,
            this
          )
          .then(res => {
            if (res.state == 0) {
              this.$Notice.error({
                title: langMap.tip[this.lang],
                desc: res.msg
              });
            } else {
              this.nodes = res.data;
            }
          });
        this.tableLoading = false;
      }
    },

    //获取触发器列表
    getTriggers() {
      const _this = this;
      if (this.task && this.task.id) {
        this.tableLoading = true;
        api
          .getData("task-server/task/trigger/" + this.task.id, this)
          .then(res => {
            if (res.state == 0) {
              this.$Notice.error({
                title: langMap.tip[this.lang],
                desc: res.msg
              });
            } else {
              res.data.forEach((item, index, arr) => {
                let data = JSON.parse(item.data);
                if (data && data !== null) {
                  //调整数据
                  if (item.type === "TYPE_FACTOR") {
                    item.routeid = data.routeid;
                    item.nodeid = data.nodeid;
                  } else if (item.type === "TYPE_POSITION") {
                    item.lat = data.lat;
                    item.lon = data.lon;
                  } else if (item.type === "TYPE_GUIDE") {
                    item.top = data.top;
                    item.left = data.left;
                    item.right = data.right;
                    item.bottom = data.bottom;
                    item.timestamp = data.timestamp;
                  }
                }
              });
              this.triggers = res.data;
            }
          });
        this.tableLoading = false;
      }
    },

    //获取已经选择作业列表
    getActions() {
      if (this.selectedTrigger && this.selectedTrigger.id) {
        this.tableLoading = true;
        api
          .getData(
            "task-server/task/trigger/action/" + this.selectedTrigger.id,
            this
          )
          .then(res => {
            if (res.state == 0) {
              this.$Notice.error({
                title: langMap.tip[this.lang],
                desc: res.msg
              });
            } else {
              res.data.forEach((item, index, arr) => {
                let data = JSON.parse(item.data);
                if (data && data !== null) {
                  //调整数据
                  if (item.name === "BO_PATROL") {
                    item.round = data.round;
                  } else if (item.name === "EQ_SPEAKER") {
                    item.switch = data.switch;
                    item.speakerDataType = data.type;
                    item.url = data.url;
                    item.voice = data.voice;
                    item.times = data.times;
                    item.interval = data.interval;
                  }
                }
              });
              this.actions = res.data;
            }
          });
        this.tableLoading = false;
      }
    },

    //添加作业
    addTaskPath() {
      if (this.paths && this.paths.length > 0) {
        this.$Notice.error({
          title: langMap.tip[this.lang],
          desc: langMap.jobAddLimitOnce[this.lang],
        });
        return;
      }
      if (
        this.task &&
        this.task.id &&
        this.selectedPath &&
        this.selectedPath !== null
      ) {
        let param = {
          taskId: this.task.id,
          pathIds: [],
          cycles: this.cycles
        };
        param.pathIds.push(this.selectedPath);
        this.btnLoading = true;

        api.postData("task-server/task/path/add", param, this).then(res => {
          this.btnLoading = false;
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.promptFromSystem[this.lang],
              desc: res.msg
            });
          } else {
            //刷新已选择作业列表
            this.getTaskPath();
            this.selectedPath = null;
            // 重置圈数
            this.cycles = 1;
          }
        });
      }
    },

    saveBase() {
      this.$refs["baseFormValidate"].validate(valid => {
        if (valid) {
          this.btnLoading = true;
          api
            .postData("task-server/task/save", this.baseForm, this)
            .then(res => {
              this.btnLoading = false;
              if (res.state == 0) {
                this.$Notice.error({
                  title: this.langMap.promptFromSystem[this.lang],
                  desc: res.msg
                });
              } else {
                this.$Notice.success({
                  title: this.langMap.promptFromSystem[this.lang],
                  desc: this.langMap.operationSuccess[this.lang],
                });
                this.task = res.data;
                this.baseForm = this.task;
                //进入下一步
                this.gotoNext(this.current + 1);
              }
            });
        }
      });
    },

    //选中行
    selectRow(currentRow, oldCurrentRow) {
      this.selectedTrigger = currentRow;
      this.getActions();
      this.addActionBtn = false;
    },

    getDic() {
      api.getData("task-server/task/get/dic", this).then(res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg
          });
        } else {
          this.triggerTypes = res.data.triggerTypes;
          this.triggerNames = res.data.triggerNames;
          this.actionNames = res.data.actionNames;
          this.actionTypes = res.data.actionTypes;
        }
      });
    },

    triggerModelShow(flag, data) {
      if (data) {
        this.triggerForm = { ...data };
      } else {
        this.triggerForm = {
          id: "",
          taskId: "",
          name: "",
          type: "",
          data: "",
          routeid: "",
          nodeid: "",
          lat: null,
          lon: null,
          top: null,
          left: null,
          right: null,
          bottom: null,
          timestamp: null
        };
      }
      this.triggerModal = flag;
      this.$refs["triggerFormValidate"].resetFields();
    },

    saveTrigger() {
      this.$refs["triggerFormValidate"].validate(valid => {
        if (valid) {
          //调整数据
          let data = {};
          if (this.triggerForm.type === "TYPE_FACTOR") {
            data.routeid = this.triggerForm.routeid;
            data.nodeid = this.triggerForm.nodeid;
          } else if (this.triggerForm.type === "TYPE_POSITION") {
            data.lat = this.triggerForm.lat;
            data.lon = this.triggerForm.lon;
          } else if (this.triggerForm.type === "TYPE_GUIDE") {
            data.top = this.triggerForm.top;
            data.left = this.triggerForm.left;
            data.right = this.triggerForm.right;
            data.bottom = this.triggerForm.bottom;
            data.timestamp = this.triggerForm.timestamp;
          }
          this.triggerForm.taskId = this.task.id;
          this.triggerForm.data = JSON.stringify(data);
          this.btnLoading = true;
          api
            .postData("task-server/task/trigger/add", this.triggerForm, this)
            .then(res => {
              this.btnLoading = false;
              if (res.state == 0) {
                this.$Notice.error({
                  title: this.langMap.promptFromSystem[this.lang],
                  desc: res.msg
                });
              } else {
                this.$Notice.success({
                  title: this.langMap.promptFromSystem[this.lang],
                  desc: this.langMap.operationSuccess[this.lang],
                });
                this.getTriggers();
                this.triggerModal = false;
              }
            });
        }
      });
    },
    cancelTrigger() {
      this.triggerModal = false;
    },

    //更新指令类型
    updateActionType(value) {
      this.actionNames.forEach((item, index, arr) => {
        if (value === item.id) {
          this.actionForm.type = item.type;
        }
      });
    },

    actionModelShow(flag, data) {
      if (data) {
        this.actionForm = { ...data };
      } else {
        this.actionForm = {
          id: "",
          taskId: "",
          triggerId: "",
          name: "",
          type: "",
          data: "",
          round: null,
          switch: false,
          speakerDataType: null,
          url: null,
          voice: null,
          times: null,
          interval: null
        };
      }
      this.actionModal = flag;
      this.$refs["actionFormValidate"].resetFields();
    },

    saveAction() {
      this.$refs["actionFormValidate"].validate(valid => {
        if (valid) {
          //调整数据
          let data = {};
          if (this.actionForm.name === "BO_PATROL") {
            data.round = this.actionForm.round;
          } else if (this.actionForm.name === "EQ_SPEAKER") {
            data.switch = this.actionForm.switch;
            data.type = this.actionForm.speakerDataType;
            data.url = this.actionForm.url;
            data.voice = this.actionForm.voice;
            data.times = this.actionForm.times;
            data.interval = this.actionForm.interval;
          }
          this.actionForm.taskId = this.task.id;
          this.actionForm.triggerId = this.selectedTrigger.id;
          this.actionForm.data = JSON.stringify(data);
          this.btnLoading = true;
          api
            .postData(
              "task-server/task/trigger/action/add",
              this.actionForm,
              this
            )
            .then(res => {
              this.btnLoading = false;
              if (res.state == 0) {
                this.$Notice.error({
                  title: langMap.promptFromSystem[this.lang],
                  desc: res.msg
                });
              } else {
                this.$Notice.success({
                  title: langMap.promptFromSystem[this.lang],
                  desc: langMap.operationSuccess[this.lang]
                });
                this.getActions();
                this.actionModal = false;
              }
            });
        }
      });
    },
    cancelAction() {
      this.actionModal = false;
    },

    init() {
      this.current = 0;
    },
    // 获取站点列表
    getStationList() {
      api.getData("task-server/robotStation/list/all", this).then(res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg
          });
        } else {
          if (res.data) {
            this.stationList = res.data || [];
          }
        }
      });
    },
    validateCyclesOnBlur() {
      // 失去焦点时验证
      const errorTip = langMap.cyclesTip[this.lang];
      const value = this.cycles
      if (value === null || value === undefined || value === '') {
        this.cycles = 1;
        this.cyclesError = errorTip;
      } else if (!Number.isInteger(value)) {
        // 不是整数，自动修正
        this.cycles = Math.round(value);
        this.cyclesError = errorTip;
      } else if (value < 1) {
        this.cycles = 1;
        this.cyclesError = errorTip;
      } else if (value > 100000) {
        this.cycles = 100000;
        this.cyclesError = '';
      } else {
        // 有效值
        this.cyclesError = '';
      }
    },
    clearCyclesError() {
      // 改变时清除错误提示
      this.cyclesError = '';
    }
  },
  watch: {
    taskData(newValue) {
      this.task = newValue ? newValue : null;
      this.baseForm.id = newValue && newValue.id ? newValue.id : "";
      this.baseForm.name = newValue && newValue.name ? newValue.name : "";
      this.baseForm.type = newValue && newValue.type ? newValue.type : "";
      this.baseForm.description =
        newValue && newValue.description ? newValue.description : "";
      // ADD
      this.baseForm.stationId = newValue ? newValue.stationId : "";
    }
  },
  mounted() {
    this.getDic();
    this.getStationList();
  }
};
</script>

<style scoped>
.step {
  margin-bottom: 40px;
}
.cycles-form-item /deep/ .ivu-form-item-error-tip {
  white-space: pre;
}
</style>
